var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v("Currently Nothing on the Dashboard, Please use the Navigation Drawer")])],1)],1),_c('v-col',{attrs:{"cols":"12","md":"6","lg":"3"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }